import { Card, Stack, Typography } from '@mui/material';
import { LineChart } from '@mui/x-charts';
import { useEffect, useState } from 'react';

import { UpcomingHolidaysCard } from '@app/components/card';
import { Strings } from '@app/constants';
import { IInterns } from '../types';
import { Card404 } from '@app/components';

interface Props {
  data: IInterns;
  CompanyGrowth: any;
}
interface ChartData {
  year: string;
  Employees: number;
  Interns: number;
}
const EmployeeInternGrowth = ({ data, CompanyGrowth }: Props) => {
  const [chartData, setChartData] = useState<ChartData[]>([]);

  useEffect(() => {
    const data = CompanyGrowth?.analysis?.map((item: any) => ({
      year: item.year,
      Employees: item.totalNoOfEmployees,
      Interns: item.totalNoOfInterns,
    }));
    setChartData(data);
  }, [CompanyGrowth]);

  return (
    <>
      <Stack sx={{ borderRadius: '5px', height: '100%' }}>
        <Stack flexDirection={{ sm: 'column', md: 'row' }}>
          <Card
            sx={{
              m: { md: 2, xs: 1 },
              borderRadius: '5px',
              width: { md: '48%', xs: '95%' },
              boxShadow: { xs: 0, md: 1 },
              display: 'flex',
              flexDirection: 'column',
              ...(Array.isArray(chartData) &&
                chartData.length > 0 && {
                  overflowX: 'auto',
                }),
            }}
          >
            <Typography variant="h6" pt={1} pl={3} mb={5}>
              {Strings.dashboard.companyGrowth}
            </Typography>
            {Array.isArray(chartData) && chartData.length > 0 ? (
              <LineChart
                height={400}
                width={450}
                sx={{ alignItems: 'center' }}
                series={[
                  { data: chartData.map((item) => item.Employees), label: 'Employee' },
                  { data: chartData.map((item) => item.Interns), label: 'Intern' },
                ]}
                xAxis={[
                  { scaleType: 'point', data: chartData.map((item) => item.year), label: 'Years' },
                ]}
                yAxis={[
                  {
                    label: 'Number of Employees & Interns',
                    min: 0,
                    max: 35,
                    tickInterval: [5],
                  },
                ]}
              />
            ) : (
              <Card404 height={240} message="Data Not Found!" />
            )}
          </Card>
          <Card
            sx={{
              borderRadius: '5px',
              width: { sm: '100%', md: '47.5%' },
              mt: { md: 2, xs: 1 },
              mb: { md: 2, xs: 1 },
              ml: { xs: 1, md: 0 },
              mr: { md: 2, xs: 1 },
            }}
          >
            <UpcomingHolidaysCard
              title={Strings.employeeDashborad.upcomingHolidays}
              holidays={data?.holidays}
            />
          </Card>
        </Stack>
      </Stack>
    </>
  );
};
export { EmployeeInternGrowth };
